var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPrinterMobile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "printer",
    clipPath: "url(#clip0_0_8)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M3.99968 12.0003H2.66624C2.31259 12.0003 1.97342 11.8598 1.72336 11.6098C1.47329 11.3597 1.3328 11.0205 1.3328 10.6669V7.33328C1.3328 6.97963 1.47329 6.64046 1.72336 6.3904C1.97342 6.14033 2.31259 5.99984 2.66624 5.99984H13.3338C13.6874 5.99984 14.0266 6.14033 14.2766 6.3904C14.5267 6.64046 14.6672 6.97963 14.6672 7.33328V10.6669C14.6672 11.0205 14.5267 11.3597 14.2766 11.6098C14.0266 11.8598 13.6874 12.0003 13.3338 12.0003H12.0003M3.99968 5.99984V1.99952C3.99968 1.82269 4.06992 1.65311 4.19496 1.52808C4.31999 1.40304 4.48958 1.3328 4.6664 1.3328H11.3336C11.5104 1.3328 11.68 1.40304 11.805 1.52808C11.9301 1.65311 12.0003 1.82269 12.0003 1.99952V5.99984M4.6664 9.33344H11.3336C11.7018 9.33344 12.0003 9.63194 12.0003 10.0002V14.0005C12.0003 14.3687 11.7018 14.6672 11.3336 14.6672H4.6664C4.29818 14.6672 3.99968 14.3687 3.99968 14.0005V10.0002C3.99968 9.63194 4.29818 9.33344 4.6664 9.33344Z",
    stroke: "#404040",
    strokeWidth: 2,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_8"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrinterMobile);
export default __webpack_public_path__ + "static/media/printer-mobile.90956df215c035725a778e3a92867b2d.svg";
export { ForwardRef as ReactComponent };